import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { ASSETS } from "@/lib/assets";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/auth/request-password-reset", { email }); setSent(true); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16 text-center">
      <img src={ASSETS.shrugging} alt="" className="w-28 mx-auto" />
      <h1 className="headline text-cream text-3xl mt-3">FORGOT <span className="text-neon">PASSWORD?</span></h1>
      {sent ? (
        <div className="comic-card p-6 mt-8">
          <p className="font-mono text-sm text-cream">If an account exists for <span className="text-neon">{email}</span>, a reset link is on its way. Check your inbox.</p>
          <Link to="/login" className="btn-neon mt-6 inline-flex" data-testid="forgot-back">Back To Login</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="comic-card p-6 mt-8 space-y-4">
          <input type="email" required placeholder="Your email" value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-ink border-3 border-black px-3 py-2.5 font-mono text-sm text-cream focus:outline-none focus:border-neon" data-testid="forgot-email" />
          <button disabled={loading} className="btn-neon w-full disabled:opacity-50" data-testid="forgot-submit">{loading ? "..." : "Send Reset Link"}</button>
        </form>
      )}
    </div>
  );
}
